import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';

import type { SimilarVehiclesEvents } from '../SimilarVehicles';

import styles from './SimilarVehiclesWrapper.module.scss';

interface SimilarVehiclesWrapperProps {
	children: React.ReactNode;
	onSimilarVehiclesVisible: SimilarVehiclesEvents['onSimilarVehiclesVisible'];
}

export const SimilarVehiclesWrapper: React.FC<SimilarVehiclesWrapperProps> = ({
	children,
	onSimilarVehiclesVisible,
}) => {
	const { inView, ref } = useInView({
		fallbackInView: false,
		threshold: 0.1,
		triggerOnce: true,
	});

	useEffect(() => {
		if (inView) {
			onSimilarVehiclesVisible?.();
		}
	}, [inView, onSimilarVehiclesVisible]);

	return (
		<div ref={ref} {...applyCypressData(cypressIds.containers.similarVehicles)} className={styles.wrapper}>
			{children}
		</div>
	);
};
